var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-breadcrumbs',{staticClass:"mb-12",attrs:{"items":_vm.breadcrumbs}}),_c('div',{staticClass:"d-flex align-center justify-space-between"},[_c('div',{staticClass:"d-flex align-start",class:{
				'align-start': _vm.$vuetify.breakpoint.xsOnly,
				'align-center': !_vm.$vuetify.breakpoint.xsOnly,
			}},[_c('back-button',{attrs:{"btnClass":{ 'mb-6': true }},on:{"click":_vm.goBack}}),_c('div',{staticClass:"d-flex flex-column",class:{
					'ml-2': _vm.$vuetify.breakpoint.xsOnly,
					'ml-6': !_vm.$vuetify.breakpoint.xsOnly,
				}},[_c('div',{staticClass:"d-flex align-center"},[_c('div',{staticStyle:{"font-weight":"600"},style:({
							fontSize: _vm.$vuetify.breakpoint.smAndDown ? '1.5rem' : '2rem',
						})},[_vm._v(" "+_vm._s(_vm._get(_vm.team, 'company.name') || 'Loading...')+" ")])]),_c('div',{staticClass:"text--secondary"},[_vm._v(" Company Settings ")])])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }